(() => {
  if (!document.querySelector(".lp-tabio_aw2026")) return;

  for (const c of ["hide-store-chrome"]) document.body.classList.add(c);
  const replayDcl = (listener, target) => {
    queueMicrotask(() => {
      try { listener.call(target, new Event("DOMContentLoaded")); }
      catch (err) { console.warn(".lp-tabio_aw2026" + " DOMContentLoaded", err); }
    });
  };
  const _docAdd = document.addEventListener.bind(document);
  document.addEventListener = function(type, listener, options) {
    if ((type === "DOMContentLoaded" || type === "domcontentloaded") && document.readyState !== "loading") {
      replayDcl(listener, document);
      return;
    }
    return _docAdd(type, listener, options);
  };
  const _winAdd = window.addEventListener.bind(window);
  window.addEventListener = function(type, listener, options) {
    if ((type === "DOMContentLoaded" || type === "domcontentloaded") && document.readyState !== "loading") {
      replayDcl(listener, window);
      return;
    }
    return _winAdd(type, listener, options);
  };

  const hideLoader = () => {
    const bg = document.querySelector(".lp-tabio_aw2026 .loader-bg");
    if (!bg || bg.dataset.lpHidden) return;
    bg.dataset.lpHidden = "1";
    if (window.jQuery) window.jQuery(bg).stop(true, true).fadeOut(800);
    else bg.style.display = "none";
  };
  const containerEl = document.querySelector(".lp-tabio_aw2026 #container") || document.getElementById("container");
try {
window.TABIO_LOOKS = [
  { "id": "01", "img": "https://cdn.shopify.com/s/files/1/0963/2520/6294/files/tabio_aw2026_01.webp", "color": "#253868", "name": "ラベンダーブルー", "code": "82", "url": "/products/011908001/?color_code=82" },
  { "id": "02", "img": "https://cdn.shopify.com/s/files/1/0963/2520/6294/files/tabio_aw2026_02.webp", "color": "#8a121a", "name": "ダークレッド", "code": "43", "url": "/products/011908001/?color_code=43" },
  { "id": "03", "img": "https://cdn.shopify.com/s/files/1/0963/2520/6294/files/tabio_aw2026_03.webp", "color": "#b1810c", "name": "マスタード", "code": "66", "url": "/products/011908001/?color_code=66" },
  { "id": "04", "img": "https://cdn.shopify.com/s/files/1/0963/2520/6294/files/tabio_aw2026_04.webp", "color": "#b19787", "name": "エクリュベージュ", "code": "05", "url": "/products/011908001/?color_code=05" },
  { "id": "05", "img": "https://cdn.shopify.com/s/files/1/0963/2520/6294/files/tabio_aw2026_05.webp", "color": "#23253c", "name": "ヴィンテージブルー", "code": "83", "url": "/products/011908001/?color_code=83" },
  { "id": "06", "img": "https://cdn.shopify.com/s/files/1/0963/2520/6294/files/tabio_aw2026_06.webp", "color": "#6a625f", "name": "スチールグレー", "code": "18", "url": "/products/011908001/?color_code=18" },
  { "id": "07", "img": "https://cdn.shopify.com/s/files/1/0963/2520/6294/files/tabio_aw2026_07.webp", "color": "#4c2a1e", "name": "ダークブラウン", "code": "23", "url": "/products/011908001/?color_code=23" },
  { "id": "08", "img": "https://cdn.shopify.com/s/files/1/0963/2520/6294/files/tabio_aw2026_08.webp", "color": "#161016", "name": "ブラックボルドー", "code": "47", "url": "/products/011908001/?color_code=47" },
  { "id": "09", "img": "https://cdn.shopify.com/s/files/1/0963/2520/6294/files/tabio_aw2026_09.webp", "color": "#7c5a29", "name": "オリーブイエロー", "code": "67", "url": "/products/011908001/?color_code=67" },
  { "id": "10", "img": "https://cdn.shopify.com/s/files/1/0963/2520/6294/files/tabio_aw2026_10.webp", "color": "#b39688", "name": "ピンクベージュ", "code": "32", "url": "/products/011908001/?color_code=32" },
  { "id": "11", "img": "https://cdn.shopify.com/s/files/1/0963/2520/6294/files/tabio_aw2026_11.webp", "color": "#b99a95", "name": "ローズピンク", "code": "31", "url": "/products/011908001/?color_code=31" },
  { "id": "12", "img": "https://cdn.shopify.com/s/files/1/0963/2520/6294/files/tabio_aw2026_12.webp", "color": "#504337", "name": "ローアンバー", "code": "26", "url": "/products/011908001/?color_code=26" },
  { "id": "13", "img": "https://cdn.shopify.com/s/files/1/0963/2520/6294/files/tabio_aw2026_13.webp", "color": "#a6b7c4", "name": "サックス", "code": "80", "url": "/products/011908001/?color_code=80" },
  { "id": "14", "img": "https://cdn.shopify.com/s/files/1/0963/2520/6294/files/tabio_aw2026_14.webp", "color": "#7c6f69", "name": "グレージュ", "code": "21", "url": "/products/011908001/?color_code=21" },
  { "id": "15", "img": "https://cdn.shopify.com/s/files/1/0963/2520/6294/files/tabio_aw2026_15.webp", "color": "#241a3f", "name": "ダークバイオレット", "code": "49", "url": "/products/011908001/?color_code=49" },
  { "id": "16", "img": "https://cdn.shopify.com/s/files/1/0963/2520/6294/files/tabio_aw2026_16.webp", "color": "#4c1230", "name": "ダークパープル", "code": "94", "url": "/products/011908001/?color_code=94" },
  { "id": "17", "img": "https://cdn.shopify.com/s/files/1/0963/2520/6294/files/tabio_aw2026_17.webp", "color": "#1f110c", "name": "コゲチャ", "code": "44", "url": "/products/011908001/?color_code=44" },
  { "id": "18", "img": "https://cdn.shopify.com/s/files/1/0963/2520/6294/files/tabio_aw2026_18.webp", "color": "#382b33", "name": "モーブ", "code": "96", "url": "/products/011908001/?color_code=96" },
  { "id": "19", "img": "https://cdn.shopify.com/s/files/1/0963/2520/6294/files/tabio_aw2026_19.webp", "color": "#597b8b", "name": "ブルーシェル", "code": "81", "url": "/products/011908001/?color_code=81" },
  { "id": "20", "img": "https://cdn.shopify.com/s/files/1/0963/2520/6294/files/tabio_aw2026_20.webp", "color": "#0a2839", "name": "ディープラグーン", "code": "88", "url": "/products/011908001/?color_code=88" },
  { "id": "21", "img": "https://cdn.shopify.com/s/files/1/0963/2520/6294/files/tabio_aw2026_21.webp", "color": "#713736", "name": "ガーネットブリック", "code": "57", "url": "/products/011908001/?color_code=57" },
  { "id": "22", "img": "https://cdn.shopify.com/s/files/1/0963/2520/6294/files/tabio_aw2026_22.webp", "color": "#4e515a", "name": "アクアグレー", "code": "14", "url": "/products/011908001/?color_code=14" },
  { "id": "23", "img": "https://cdn.shopify.com/s/files/1/0963/2520/6294/files/tabio_aw2026_23.webp", "color": "#4c1b11", "name": "チョコレートブラウン", "code": "22", "url": "/products/011908001/?color_code=22" },
  { "id": "24", "img": "https://cdn.shopify.com/s/files/1/0963/2520/6294/files/tabio_aw2026_24.webp", "color": "#1e1d22", "name": "ネイビーグレー", "code": "89", "url": "/products/011908001/?color_code=89" },
  { "id": "25", "img": "https://cdn.shopify.com/s/files/1/0963/2520/6294/files/tabio_aw2026_25.webp", "color": "#271d1e", "name": "チャコールブラウン", "code": "17", "url": "/products/011908001/?color_code=17" },
  { "id": "26", "img": "https://cdn.shopify.com/s/files/1/0963/2520/6294/files/tabio_aw2026_26.webp", "color": "#b1a09a", "name": "ピーチベージュ", "code": "07", "url": "/products/011908001/?color_code=07" },
  { "id": "27", "img": "https://cdn.shopify.com/s/files/1/0963/2520/6294/files/tabio_aw2026_27.webp", "color": "#16130f", "name": "カーキブラウン", "code": "28", "url": "/products/011908001/?color_code=28" },
  { "id": "28", "img": "https://cdn.shopify.com/s/files/1/0963/2520/6294/files/tabio_aw2026_28.webp", "color": "#243a1d", "name": "ツリーグリーン", "code": "72", "url": "/products/011908001/?color_code=72" }
];

} catch (err) { console.warn(".lp-tabio_aw2026" + " script failed", err); }
try {
const looks = window.TABIO_LOOKS;
const track = document.getElementById('track');
const root = document.documentElement;
const label = document.getElementById('label');

const mqMobile = window.matchMedia('(max-width:767px)');

const videoItem = {
  video:true,
  color:'#1b1b20',
  name:'ALL LOOKS',
  pc:'https://cdn.shopify.com/videos/c/vp/80f62e9ed16c4b13b7d3945ee90858ad/80f62e9ed16c4b13b7d3945ee90858ad.HD-720p-1.6Mbps-98095061.mp4',
  sp:'https://cdn.shopify.com/videos/c/vp/00e71783b46d42578e0fb81cc5dfa38a/00e71783b46d42578e0fb81cc5dfa38a.HD-1080p-2.5Mbps-98095090.mp4'
};
const items = [videoItem, ...looks];
const N = items.length;
let cur = 0;
let hoverIdx = -1;
let videoEl = null;
let vloadEl = null;
let videoLoaded = false;

function videoSrc(){ return mqMobile.matches ? videoItem.sp : videoItem.pc; }

function markVideoReady(){
  videoLoaded = true;
  if(vloadEl) vloadEl.classList.add('hidden');
}

function ensureVideoLoaded(){
  if(!videoEl || videoLoaded && videoEl.src) return;
  const want = videoSrc();
  if(!videoEl.src || !videoEl.src.endsWith(want)){
    videoEl.src = want;
    videoEl.load();
  }
}

const cards = items.map((item,i)=>{
  const c = document.createElement('div');
  c.className = 'card' + (item.video ? ' video-card' : '');
  if(item.video){
    c.innerHTML = `<video muted loop playsinline preload="none"></video>
                   <div class="vload"><img src="https://cdn.shopify.com/s/files/1/0963/2520/6294/files/tabio_aw2026_01.webp" alt=""></div>
                   <span class="num" style="background:color-mix(in srgb, ${item.color} 82%, rgba(0,0,0,.55))">VIDEO</span>
                   <div class="bar" style="background:${item.color}"></div>`;
    videoEl = c.querySelector('video');
    vloadEl = c.querySelector('.vload');
    videoEl.addEventListener('canplay', markVideoReady);
    videoEl.addEventListener('playing', markVideoReady);
    videoEl.addEventListener('loadeddata', markVideoReady);
    videoEl.addEventListener('error', ()=>{ if(vloadEl) vloadEl.classList.add('hidden'); });
  } else {
    c.innerHTML = `<img src="${item.img}" alt="look ${item.id}" loading="lazy">
                   <span class="num" style="background:color-mix(in srgb, ${item.color} 82%, rgba(0,0,0,.55))">LOOK ${item.id}</span>
                   <div class="bar" style="background:${item.color}"></div>`;
  }
  track.appendChild(c);
  return c;
});

mqMobile.addEventListener('change',()=>{
  if(!videoEl || !videoLoaded) return;
  const want = videoSrc();
  if(!videoEl.src.endsWith(want)){
    videoLoaded = false;
    if(vloadEl) vloadEl.classList.remove('hidden');
    videoEl.src = want;
    videoEl.load();
    if(items[cur] && items[cur].video && !introMode) videoEl.play().catch(()=>{});
  }
});

let introMode = false;
function render(){
  const visibleRange = introMode ? 1 : 3;
  cards.forEach((c,i)=>{
    let off = i - cur;
    if(off >  N/2) off -= N;
    if(off < -N/2) off += N;
    const abs = Math.abs(off);
    const x = off * 62;
    const z = -abs * 220;
    const ry = off * -9;
    const scale = Math.max(0.5, 1 - abs*0.12);
    const lifted = (i===hoverIdx && i!==cur && !introMode);
    const liftY  = lifted ? -14 : 0;
    const liftZ  = lifted ? 60  : 0;
    c.style.transform =
      `translate(-50%,-50%) translateX(${x}%) translateY(${liftY}px) translateZ(${z+liftZ}px) rotateY(${ry}deg) scale(${scale})`;
    const hidden = abs > visibleRange;
    c.style.opacity = hidden ? 0 : 1 - abs*0.14;
    c.style.visibility = hidden ? 'hidden' : 'visible';
    c.style.zIndex = lifted ? 120 : 100 - abs;
    c.style.filter = (introMode || abs===0 || lifted) ? 'none' : `brightness(${1-abs*0.12})`;
    c.classList.toggle('active', i===cur);
    c.classList.toggle('lifted', lifted);
  });
  const item = items[cur];
  root.style.setProperty('--accent', item.color);

  const videoIdx = 0;
  let voff = videoIdx - cur;
  if(voff >  N/2) voff -= N;
  if(voff < -N/2) voff += N;
  const videoNear = Math.abs(voff) <= 1;
  if(videoEl && videoNear && !introMode){ ensureVideoLoaded(); }

  if(item.video){
    label.textContent = 'VIDEO  ·  ' + item.name;
    if(videoEl && !introMode){ ensureVideoLoaded(); videoEl.play().catch(()=>{}); }
  }else{
    label.textContent = 'LOOK ' + item.id + '  ·  ' + (item.name || item.color.toUpperCase());
    if(videoEl){ videoEl.pause(); }
  }
}

function go(dir){
  cur = (cur + dir + N) % N;
  render();
}
document.getElementById('next').onclick = ()=>go(1);
document.getElementById('prev').onclick = ()=>go(-1);
window.addEventListener('keydown',e=>{
  if(e.key==='ArrowRight') document.getElementById('next').click();
  if(e.key==='ArrowLeft')  document.getElementById('prev').click();
});
let sx=null, sy=null, moved=false;
track.addEventListener('pointerdown',e=>{ sx=e.clientX; sy=e.clientY; moved=false; });
track.addEventListener('pointermove',e=>{
  if(sx===null) return;
  if(Math.abs(e.clientX-sx)>6 || Math.abs(e.clientY-sy)>6) moved=true;
});
window.addEventListener('pointerup',e=>{
  if(sx===null){ return; }
  const d=e.clientX-sx;
  if(Math.abs(d)>40){
    if(d<0) go(1); else go(-1);
    sx=null; return;
  }
  if(!moved){
    const clickX = e.clientX;
    let best=null, bestDist=Infinity;
    cards.forEach((c,i)=>{
      if(getComputedStyle(c).visibility!=='visible') return;
      const r=c.getBoundingClientRect();
      const cx=r.left+r.width/2;
      const dist=Math.abs(cx-clickX);
      if(dist<bestDist){ bestDist=dist; best=i; }
    });
    if(best!==null){
      let off=best-cur;
      if(off> N/2) off-=N;
      if(off< -N/2) off+=N;
      if(off!==0){ go(off); }
      else {
        const it = items[cur];
        if(it && it.url){ window.open(it.url, '_blank', 'noopener'); }
      }
    }
  }
  sx=null;
});
const AUTO_MS = 4800;
const VIDEO_MS = 35000;
let auto=null;
let resumeTimer=null;
function scheduleNext(){
  clearTimeout(auto);
  const currentItem = items[cur];
  const delay = currentItem.video ? VIDEO_MS : AUTO_MS;
  auto=setTimeout(()=>{cur=(cur+1)%N;render();scheduleNext();},delay);
}
function pauseAuto(){
  clearTimeout(auto);
  clearTimeout(resumeTimer);
  resumeTimer=setTimeout(scheduleNext,5000);
}
track.addEventListener('pointerdown',pauseAuto);
document.querySelector('.nav').addEventListener('click',pauseAuto);
window.addEventListener('keydown',e=>{
  if(e.key==='ArrowRight'||e.key==='ArrowLeft') pauseAuto();
});

/* ===== INTRO SWEEP =====
   On load, cards stream past then decelerate to a stop —
   instantly showing how many colors / looks the collection has.
   Kept lightweight (one pass, few visible cards) so mobile GPUs don't choke. */
const stage = document.getElementById('stage');
const reduceMotion = window.matchMedia &&
  window.matchMedia('(prefers-reduced-motion: reduce)').matches;

function finishIntro(){
  introMode = false;
  stage.classList.remove('intro');
  cur = 0;
  render();
  scheduleNext();
}

function introSweep(){
  introMode = true;
  stage.classList.add('intro');
  const steps = Math.floor(N / 2);
  let i = 0;
  cur = 0;
  render();
  function step(){
    cur = (cur + 1) % N;
    render();
    i++;
    if(i < steps){
      const t = i / steps;
      const delay = 70 + t * t * 210;
      setTimeout(step, delay);
    } else {
      finishIntro();
    }
  }
  setTimeout(step, 300);
}

/* ===== PC 3D TILT + HOVER LIFT =====
   The whole card assembly tilts subtly toward the cursor (Apple-style),
   and the side card the cursor rests on rises toward the viewer.
   Enabled only on fine-pointer, wide (PC) viewports; respects reduced-motion. */
const mqPC   = window.matchMedia('(min-width:768px)');
const mqFine = window.matchMedia('(pointer:fine)');
function tiltEnabled(){ return mqPC.matches && mqFine.matches && !reduceMotion; }

let tiltTargX = 0, tiltTargY = 0, tiltCurX = 0, tiltCurY = 0, tiltRAF = null;
const TILT_MAX_Y = 5;
const TILT_MAX_X = 4;

function tiltLoop(){
  tiltCurX += (tiltTargX - tiltCurX) * 0.12;
  tiltCurY += (tiltTargY - tiltCurY) * 0.12;
  track.style.setProperty('--tiltX', tiltCurX.toFixed(2) + 'deg');
  track.style.setProperty('--tiltY', tiltCurY.toFixed(2) + 'deg');
  if(Math.abs(tiltTargX-tiltCurX) > 0.01 || Math.abs(tiltTargY-tiltCurY) > 0.01){
    tiltRAF = requestAnimationFrame(tiltLoop);
  } else {
    tiltRAF = null;
  }
}
function kickTilt(){ if(tiltRAF===null) tiltRAF = requestAnimationFrame(tiltLoop); }

stage.addEventListener('mousemove', e=>{
  if(!tiltEnabled() || introMode) return;
  const nx = (e.clientX / window.innerWidth  - 0.5) * 2;
  const ny = (e.clientY / window.innerHeight - 0.5) * 2;
  tiltTargY =  nx * TILT_MAX_Y;
  tiltTargX = -ny * TILT_MAX_X;
  kickTilt();

  let hit = -1;
  cards.forEach((c,i)=>{
    if(i===cur) return;
    if(getComputedStyle(c).visibility!=='visible') return;
    const r=c.getBoundingClientRect();
    if(e.clientX>=r.left && e.clientX<=r.right && e.clientY>=r.top && e.clientY<=r.bottom){
      hit = i;
    }
  });
  if(hit!==hoverIdx){ hoverIdx=hit; render(); }
});
stage.addEventListener('mouseleave', ()=>{
  tiltTargX = 0; tiltTargY = 0; kickTilt();
  if(hoverIdx!==-1){ hoverIdx=-1; render(); }
});
mqPC.addEventListener('change',()=>{
  tiltTargX=0; tiltTargY=0; kickTilt();
  if(hoverIdx!==-1){ hoverIdx=-1; render(); }
});

render();
if(reduceMotion){
  scheduleNext();
}else{
  introSweep();
}

} catch (err) { console.warn(".lp-tabio_aw2026" + " script failed", err); }
  if (window.jQuery) window.$ = window.jQuery;
  const revealLazy = () => {
    const $ = window.jQuery;
    const rootEl = document.querySelector(".lp-tabio_aw2026");
    if (!$ || !rootEl) return;
    $("img.lazy", rootEl).each(function() {
      const real = this.getAttribute("data-original") || this.getAttribute("data-lazy");
      const src = this.getAttribute("src") || "";
      if (real && (!src || /preload\.gif|dummy\.jpe?g/i.test(src))) this.setAttribute("src", real);
      try { $(this).trigger("appear"); } catch (err) {}
    });
    try { $(window).trigger("scroll"); } catch (err) {}
  };
  setTimeout(revealLazy, 0);
  setTimeout(revealLazy, 400);

  let lpLoadAttempts = 0;
  const fireJqueryLoad = () => {
    const $ = window.jQuery;
    if ($ && window.$ !== $) window.$ = $;
    if (!$ || typeof $._data !== "function") {
      if (lpLoadAttempts++ < 40) setTimeout(fireJqueryLoad, 50);
      return;
    }
    let list;
    try {
      const ev = $._data(window, "events");
      list = ev && ev.load;
    } catch (err) {
      console.warn(".lp-tabio_aw2026" + " load dispatch failed", err);
      return;
    }
    if (!list || !list.length) {
      if (lpLoadAttempts++ < 40) setTimeout(fireJqueryLoad, 50);
      return;
    }
    for (const h of Array.from(list)) {
      try { h.handler.call(window, $.Event("load")); }
      catch (err) { console.warn(".lp-tabio_aw2026" + " load handler failed", err); }
    }
    const w = window.innerWidth || document.documentElement.clientWidth || 0;
    const pendingLineup = document.querySelector(".lp-tabio_aw2026 .contents07-inner .item-area:not(.slick-initialized)");
    if (pendingLineup && w > 768 && lpLoadAttempts++ < 40) setTimeout(fireJqueryLoad, 100);
  };
  const scheduleLoad = () => setTimeout(fireJqueryLoad, 0);
  if (document.readyState === "complete") scheduleLoad();
  else window.addEventListener("load", scheduleLoad);
  setTimeout(fireJqueryLoad, 200);
  setTimeout(fireJqueryLoad, 800);

  setTimeout(hideLoader, 4500);
})();
